import { styled } from '@mui/material/styles';
import { Box, LinearProgress, Typography } from '@mui/material';

export const ContainerStyled = styled('div', {
  name: 'ContainerStyled',
})(({ theme }) => ({
  padding: theme.spacing(2, 0),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const SectionStyled = styled('div', {
  name: 'SectionStyled',
})(({ theme }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const SectionHeaderStyled = styled(Box, {
  name: 'SectionHeaderStyled',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const SectionTitleStyled = styled(Typography, {
  name: 'SectionTitleStyled',
})(() => ({
  fontWeight: 600,
}));

export const SectionDescriptionStyled = styled(Typography, {
  name: 'SectionDescriptionStyled',
})(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const SearchInputContainerStyled = styled(Box, {
  name: 'SearchInputContainerStyled',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
}));

export const LinearProgressStyled = styled(LinearProgress, {
  name: 'LinearProgressStyled',
})(() => ({
  marginTop: '1rem',
}));

export const NoDataMessageStyled = styled(Typography, {
  name: 'NoDataMessageStyled',
})(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  padding: theme.spacing(2, 0),
}));
